import { Box, Stack } from "@mui/material";
import { COLORS } from "assets";
import { PropsWithChildren } from "react";

export interface FilterBarProps {
  trailing?: React.ReactNode;
  /** Light surface (Figma content panel). Default true. */
  light?: boolean;
}

const lightControlSx = {
  "& .MuiFormHelperText-root": {
    display: "none",
    m: 0
  },
  "& > div": {
    minWidth: 0
  },
  "& .MuiFormControl-root": {
    m: 0,
    width: "100%",
    verticalAlign: "middle"
  },
  "& .MuiInputBase-root": {
    bgcolor: `${COLORS.surface.card} !important`,
    color: `${COLORS.surface.primaryText} !important`,
    borderRadius: `${COLORS.radius.pill}px !important`,
    border: `1px solid ${COLORS.surface.border}`,
    fontSize: "0.875rem",
    fontWeight: 500,
    height: "40px !important",
    minHeight: "40px !important",
    boxSizing: "border-box",
    pr: "12px !important"
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none !important"
  },
  "& .MuiSelect-select": {
    py: "0 !important",
    pl: "16px !important",
    pr: "32px !important",
    height: "40px !important",
    lineHeight: "40px !important",
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    boxSizing: "border-box"
  },
  "& .MuiSelect-icon": {
    right: "12px !important",
    top: "50% !important",
    transform: "translateY(-50%)",
    color: COLORS.surface.secondaryText,
    pointerEvents: "none"
  },
  "& [class*='StyledInputRoot']": {
    background: `${COLORS.surface.card} !important`,
    borderRadius: `${COLORS.radius.pill}px !important`,
    border: `1px solid ${COLORS.surface.border}`,
    color: COLORS.surface.primaryText,
    height: 40,
    minHeight: 40,
    boxSizing: "border-box"
  },
  "& input, & .MuiSelect-select": {
    color: `${COLORS.surface.primaryText} !important`,
    WebkitTextFillColor: `${COLORS.surface.primaryText} !important`
  },
  "& label": {
    display: "none"
  }
};

export default function FilterBar({ children, trailing, light = true }: PropsWithChildren<FilterBarProps>) {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      justifyContent="flex-start"
      gap={1.5}
      mb={light ? 0 : 2.5}
      width="100%"
      minWidth={0}
      sx={
        light
          ? lightControlSx
          : {
              px: 1.5,
              py: 1.25,
              borderRadius: `${COLORS.radius.md}px`,
              bgcolor: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.1)",
              ...lightControlSx
            }
      }
    >
      <Stack
        direction="row"
        flexWrap="wrap"
        gap={1.5}
        flex={1}
        minWidth={0}
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
      >
        {children}
        {trailing ? (
          <Box flexShrink={0} display="flex" alignItems="center">
            {trailing}
          </Box>
        ) : null}
      </Stack>
    </Box>
  );
}
